import Layout from "@/components/feature/Layout";
import CtaBand from "@/components/feature/CtaBand";
import usePageMeta from "@/hooks/usePageMeta";
import { homeFaqs, seoKeywords } from "@/mocks/siteData";
import HeroSection from "@/pages/home/components/HeroSection";
import StatsStrip from "@/pages/home/components/StatsStrip";
import ChannelGrid from "@/pages/home/components/ChannelGrid";
import ProcessSteps from "@/pages/home/components/ProcessSteps";
import PrivacySection from "@/pages/home/components/PrivacySection";
import CategorySection from "@/pages/home/components/CategorySection";
import FaqPreview from "@/pages/home/components/FaqPreview";
import AboutPreview from "@/pages/home/components/AboutPreview";

const homeTitle = "潜声投稿 - 匿名爆料投稿平台 | 图文·视频·录音素材安全提交";
const homeDesc =
  "潜声投稿是面向公众的匿名爆料投稿平台，提供图文投稿通道、匿名私信投稿、视频素材上传与录音证据提交入口。全程可匿名、加密传输、素材统一脱敏，帮助你安全发声、快速直达编辑。";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "潜声投稿",
    alternateName: "QianSheng Tips",
    url: "https://qiansheng.online/",
    inLanguage: "zh-CN",
    description: homeDesc,
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "潜声投稿",
    url: "https://qiansheng.online/",
    email: "tips@qiansheng.online",
    description:
      "面向公众的匿名爆料投稿平台，提供图文、匿名私信、视频素材与录音证据四类安全投稿通道。",
    knowsAbout: ["匿名爆料投稿", "视频素材上传", "录音证据提交", "图文投稿通道"],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: homeFaqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: { "@type": "Answer", text: faq.a },
    })),
  },
];

export default function Home() {
  usePageMeta({
    title: homeTitle,
    description: homeDesc,
    keywords: seoKeywords,
    path: "/",
    jsonLd,
  });

  return (
    <Layout>
      <HeroSection />
      <StatsStrip />
      <ChannelGrid />
      <ProcessSteps />
      <PrivacySection />
      <CategorySection />
      <FaqPreview />
      <AboutPreview />
      <CtaBand
        title="手里有线索，别让它烂在相册里"
        desc="选择适合你的通道，几分钟就能完成提交。完全匿名也可以，我们只关心线索本身。"
        primaryLabel="立即前往投稿通道"
        primaryTo="/channels"
        secondaryLabel="先看看安全指南"
        secondaryTo="/guide"
      />
    </Layout>
  );
}